import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NavigationState, featureKey } from './navigation.state';

const selectNavigationState = createFeatureSelector<NavigationState>(featureKey);

export const selectLoadingWorkstockCounter = createSelector(selectNavigationState, state => state.loadingWorkstockCounter);

export const selectWorkstockCounter = createSelector(selectNavigationState, state => state.workstockCounter);

export const selectLoadingDWSMCounter = createSelector(selectNavigationState, state => state.loadingDWSMCounter);

export const selectDWSMCounter = createSelector(selectNavigationState, state => state.dwsmCounter);

export const selectWorkstockFavoriteCounterNavigation = createSelector(selectNavigationState, state => state?.favoriteCounter);
